import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BookingFlow } from "@/pages/BookingFlow";
import { StaffRoutes } from "@/pages/staff/StaffRoutes";
import { CustomerFormPortal } from "@/pages/CustomerFormPortal";
import PublicMedicalForm from "@/pages/public/PublicMedicalForm";
import {
    BookingPaymentSuccess,
    BookingPaymentCancelled,
    BookingPaymentPending,
} from "@/pages/BookingPaymentReturn";
import { AuthProvider } from "@/context/AuthContext";
import { CartPayment } from "@/pages/CartPayment";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/booking/cart-payment" element={<CartPayment />} />
                        <Route path="/staff/*" element={<StaffRoutes />} />
                        <Route path="/f/:token" element={<CustomerFormPortal />} />
                        <Route path="/forms/f/:token" element={<PublicMedicalForm />} />
                        <Route path="/booking/payment-success" element={<BookingPaymentSuccess />} />
                        <Route path="/booking/payment-cancelled" element={<BookingPaymentCancelled />} />
                        <Route path="/booking/payment-pending" element={<BookingPaymentPending />} />
                        <Route path="/" element={<BookingFlow />} />
                        <Route path="*" element={<BookingFlow />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
